const opacity = (state = 1, action)=>{
    if(action.type === "SET_OPACITY"){
        state = action.opacity
    }
    return state;
}

export default opacity;